import {
  FormStateUpdate,
  FormStates,
} from "Store/priceCalculation/priceCalculationInterfaces";
import {
  updatePriceCalculationFormState,
  updatePriceCalculationFormStates,
} from "Store/priceCalculation/priceCalculationSlice";
import {
  mapLocalStorageAndQueryParamsToForm,
  saveFormValuesToLocalStorage,
} from "Utils/localStorage";
import { put, select, takeLatest } from "redux-saga/effects";
import {
  getSavedStateFromLocalStorageFailed,
  getSavedStateFromLocalStorageStart,
  getSavedStateFromLocalStorageSucceeded,
  saveStateToLocalStorageFailed,
  saveStateToLocalStorageSucceeded,
} from "./localStorageSlice";

import { ReduxState } from "Store/rootReducer";

const priceCalculationFormStatesSelector = (state: ReduxState): any =>
  state.priceCalculation.priceCalculationFormStates;

export function* saveFormStateToLocalStorage({ payload }: any): Generator {
  try {
    saveFormValuesToLocalStorage(payload as FormStateUpdate);
    yield put(saveStateToLocalStorageSucceeded());
  } catch (e) {
    yield put(saveStateToLocalStorageFailed());
  }
}

export function* getFormStateFromLocalStorage(): Generator {
  try {
    const existingState = yield select(priceCalculationFormStatesSelector);
    yield put(
      updatePriceCalculationFormStates(
        mapLocalStorageAndQueryParamsToForm(existingState as FormStates),
      ),
    );
    yield put(getSavedStateFromLocalStorageSucceeded());
  } catch (e) {
    yield put(getSavedStateFromLocalStorageFailed());
  }
}

export function* localStorageSaga(): Generator {
  yield takeLatest(
    updatePriceCalculationFormState,
    saveFormStateToLocalStorage,
  );
  yield takeLatest(
    getSavedStateFromLocalStorageStart,
    getFormStateFromLocalStorage,
  );
}
